<template>
  <div>
    <div class="comm_popup_wrap_medium">
      <div class="comm_title_wrap">
        <h4>{{ applicationName }}</h4>
      </div>
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsData0'"
        :showDisplayCountControl="false"
      >
        <div class="btn_wrapR">
          <sui-button
            v-permission:download="pageId"
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="onDownloadExcel"
          >
            {{ $t("MSG_BTN_EXCEL_DOWN") }}
          </sui-button>
        </div>
      </sui-grid>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="closePopup"
      >
        {{ $t("MSG_BTN_CFRM") }}
      </sui-button>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PGE_CMP_00014_P01', // eslint-disable-line vue/name-property-casing
  props: {
    pageId: {
      type: String,
      default: 'PGE_CMP_00014',
    },
    searchBox: {
      type: Object,
      default() {
        return {
          siteId: { key: '', label: '' },
          systemUseSearchConditionCode: { key: '', label: '' },
          startDTM: '',
          endDTM: '',
        };
      },
    },
    popupType: {
      type: String,
      default: null, // A: application, M: menu
    },
    selectedId: {
      type: String,
      required: true,
      validator(value) {
        return (utils.isEmpty(value) === false);
      },
    },
    applicationName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_USR_NM'),
        datafield: 'userId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '2', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            datafieldMap: {
              displayLanguageId: 'displayLanguageId',
              loginId: 'loginId',
              knoxId: 'knoxId',
              userName: 'userName',
              userGlobalName: 'userGlobalName',
              departmentName: 'departmentName',
              departmentEnglishName: 'departmentEnglishName',
            },
          }, this.dsData0, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_DEPT_NM'),
        datafield: 'departmentDisplayName',
      }, {
        text: this.$t('MSG_TXT_ITCN_NUM'),
        datafield: 'connectionNumber',
        width: 100,
      }],

      // excel
      excelGridColumnsUser: [{
        text: this.$t('MSG_TXT_USR_ID'),
        datafield: 'knoxId',
      }, {
        text: this.$t('MSG_TXT_USR_NM'),
        datafield: 'userName',
      }, {
        text: this.$t('MSG_TXT_ITCN_NUM'),
        datafield: 'connectionNumber',
        width: 100,
      }],

      excelGridColumnsDept: [{
        text: this.$t('MSG_TXT_DEPT_NM'),
        datafield: 'departmentDisplayName',
      }, {
        text: this.$t('MSG_TXT_ITCN_NUM'),
        datafield: 'connectionNumber',
        width: 100,
      }],
    };
  },
  datasets: [{
    id: 'dsData0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'menuLogObjectId',
      type: 'string',
      map: 'menuLogObjectId',
    }, {
      name: 'userId',
      type: 'string',
      map: 'userId',
    }, {
      name: 'departmentId',
      type: 'string',
      map: 'departmentId',
    }, {
      name: 'departmentDisplayName',
      type: 'string',
      map: 'departmentDisplayName',
    }, {
      name: 'connectionNumber',
      type: 'string',
      map: 'connectionNumber',
    }, {
      name: 'displayLanguageId',
      type: 'string',
      map: 'displayLanguageId',
    }, {
      name: 'loginId',
      type: 'string',
      map: 'loginId',
    }, {
      name: 'knoxId',
      type: 'string',
      map: 'knoxId',
    }, {
      name: 'userName',
      type: 'string',
      map: 'userName',
    }, {
      name: 'userGlobalName',
      type: 'string',
      map: 'userGlobalName',
    }, {
      name: 'departmentName',
      type: 'string',
      map: 'departmentName',
    }, {
      name: 'departmentEnglishName',
      type: 'string',
      map: 'departmentEnglishName',
    }],
  }],
  computed: {},
  watch: {},
  mounted() {
    // this.searchConnectionNumber();
    const { selectedId } = this.$props;
    const { popupType } = this.$props;

    if (popupType === 'A') {
      // applicationID|portalId
      if (utils.indexOf(selectedId, '|') !== -1) {
        const newValues = selectedId.split('|');

        const sApplicationId = newValues[0];
        const sPortalId = newValues[1];

        this.searchApplicationConnectionNumber(sApplicationId, sPortalId);
      }
    } else if (popupType === 'M') {
      const menuLogObjectId = selectedId;
      this.searchMenuConnectionNumber(menuLogObjectId);
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /** ***************************************************************************
      이벤트 영역
    ***************************************************************************** */
    onDownloadExcel() {
      const sPageId = this.$options.name;
      let objGridColumns = {};
      const objGridDataset = this.dsData0;

      const { searchBox } = this.$props;

      if (searchBox.systemUseSearchConditionCode.key === 'U') {
        objGridColumns = this.excelGridColumnsUser;
      } else if (searchBox.systemUseSearchConditionCode.key === 'D') {
        objGridColumns = this.excelGridColumnsDept;
      }

      const sToday = utils.now('YYYYMMDD');
      const sExcelName = `menuStatus_pop_${sToday}.xlsx`;

      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName);
    },


    /** ***************************************************************************
    함수 영역
    ***************************************************************************** */
    setShowedColumns() {
      const { grid } = this.$refs;
      const { searchBox } = this.$props;
      const showedColumns = [
        'connectionNumber',
      ];

      if (searchBox.systemUseSearchConditionCode.key === 'U') {
        showedColumns.push('userId');
      }
      if (searchBox.systemUseSearchConditionCode.key === 'D') {
        showedColumns.push('departmentDisplayName');
      }

      grid.setShowedColumns(showedColumns);
    },
    searchApplicationConnectionNumber(sApplicationId, sPortalId) {
      const { searchBox } = this.$props;

      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(searchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});

      utils.assign(queryParams, { portalId: sPortalId });

      http.request(this.pageId, 'DTS_CMP_00042', {
        path: {
          'application-id': sApplicationId,
        },
        query: queryParams,
      }).then(res => {
        this.dsData0.setRawData(res.data);
        this.setShowedColumns();
      }).catch(error => {
        console.log(error);
      });
    },
    searchMenuConnectionNumber(sMenuLogObjectId) {
      const { searchBox } = this.$props;

      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(searchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});

      http.request(this.pageId, 'DTS_CMP_00043', {
        path: {
          'menu-log-object-id': sMenuLogObjectId,
        },
        query: queryParams,
      }).then(res => {
        this.dsData0.setRawData(res.data);
        this.setShowedColumns();
      }).catch(error => {
        console.log(error);
      });
    },
    closePopup() {
      this.$emit('onClose');
    },
  },
};
</script>
<style scoped>
</style>
